let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("dWaws"), load("jToRd")]).then(() => parcelRequire('5mCjA'));